<script lang="ts" setup="">
import { NIcon } from '@novonordisk/studyhub-novoui/vue'
</script>

<template>
  <div
    data-test="no-results-container"
    class="text-ui-label-14 text-general-primary flex h-[161px] items-center justify-center overflow-y-auto"
  >
    <div
      data-test="no-results-content"
      class="text-center"
    >
      <NIcon
        data-test="no-results-icon"
        class="fill-general-primary mx-auto mb-2"
        icon="unavailable"
        :size="16"
      />
      <slot />
    </div>
  </div>
</template>
